import React from 'react';
import Banner from '../Components/Banner';
import { useLanguage } from '../context/LanguageContext';

function About() {
  const { t } = useLanguage();

  return (
    <div className="page-wrap">
      <Banner
        pageName={t.pages.about}
        pageLink="/about"
        subtitle={t.about.subtitle}
        eyebrow="Innovative Horizons"
        image="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1800&q=80"
      />

      <section className="section">
        <div className="container split-panel">
          <div>
            <div className="section-title">
              <div className="eyebrow">Innovative Horizons</div>
              <h2>{t.about.title}</h2>
              <p>{t.about.intro}</p>
            </div>
            <p className="body-copy">{t.about.body}</p>
          </div>

          <div
            className="visual-block"
            style={{
              backgroundImage:
                "url('https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1400&q=80')"
            }}
          >
            <div className="visual-overlay">
              <h3 style={{ marginBottom: 10 }}>Innovative Horizons</h3>
              <p style={{ margin: 0 }}>
                Diseño elegante, comunicación clara y tecnología para proyectos con
                proyección institucional.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section band">
        <div className="container">
          <div className="grid-3">
            {t.about.pillars.map((item) => (
              <article className="feature-card" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-title center">
            <div className="eyebrow">Method</div>
            <h2>{t.about.title}</h2>
            <p>{t.about.intro}</p>
          </div>

          <div className="timeline">
            {t.about.timeline.map((item) => (
              <article className="timeline-item" key={item.phase}>
                <div className="timeline-phase">{item.phase}</div>
                <div>
                  <h3 style={{ margin: '0 0 8px' }}>{item.title}</h3>
                  <p
                    style={{
                      margin: 0,
                      color: 'var(--muted)',
                      lineHeight: 1.8
                    }}
                  >
                    {item.text}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;